import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent extends BaseComponent implements OnInit {
  roles: any = [];
  role: any = {};

  constructor(injector: Injector) { super(injector) }

  async ngOnInit()  {
    this.loader.show();
    await this.getData();
    this.role = {id: 0, name: ""};
    this.loader.hide();

  }
  async getData(){
    this.roles = await this.db.get("Role","getRoles");
  }

  async add(){
    this.role = {id: 0, name: ""};
  }

  selectRole(r: any){
    this.role = r;
  }

  async submit() {
    this.loader.show()
    if (this.role.id == 0){
      await this.db.post("Role","addrole",null,{RoleName: this.role.name});
    }else{
      await this.db.put("Role","changerole",null,{RoleId: this.role.id,RoleNAme: this.role.name});
    }
    
    this.roles = await this.db.get("Role","getRoles");
    this.role = {id: 0, name: ""};
    this.loader.hide();
  }
  async delete(role: any){
    await this.db.delete("Role","deleterole",{roleid: role.id});
    this.roles = await this.db.get("Role","getRoles");
  }

}
